// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__zRo__","gradientFlash":"Skeleton_gradientFlash___3LKB","round":"Skeleton_round__3k965"};